import { nanoid } from 'nanoid';
export class EventBroker {
    constructor(emitter, options) {
        this._emitter = emitter;
        this._eventName = options?.eventName || nanoid();
    }
    getEmitter() {
        return this._emitter;
    }
    register(cb) {
        this._emitter.on(this._eventName, cb);
        return () => {
            this.unRegister(cb);
        };
    }
    registerOnce(cb) {
        this._emitter.once(this._eventName, cb);
        return () => {
            this.unRegister(cb);
        };
    }
    unRegister(cb) {
        this._emitter.removeListener(this._eventName, cb);
    }
    registerEnsureOnce(cb) {
        this.unRegister(cb);
        return this.register(cb);
    }
    /**
     * Alias for registerEnsureOnce
     * @param cb Calback to register
     * @returns an unregister callback
     */
    reo(cb) {
        return this.registerEnsureOnce(cb);
    }
    emit(data) {
        this._emitter.emit(this._eventName, data);
    }
}
//# sourceMappingURL=EventBroker.js.map